export function createSearchHandler(searchFn, delay = 300, cancelFn = null) {
  let running = false
  let timer = null

  const execute = async (value) => {
    if (running) {
      if (typeof cancelFn === 'function') {
        cancelFn()
      }
      running = false
    }
    running = true
    try {
      await searchFn(value)
    } finally {
      running = false
    }
  }

  const run = (value) => {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      timer = null
      execute(value)
    }, delay)
  }

  const cancel = () => {
    if (timer) {
      clearTimeout(timer)
      timer = null
    }
    if (running && typeof cancelFn === 'function') {
      cancelFn()
      running = false
    }
  }

  return { run, cancel }
}
